/* Court Vibes: einheitlicher hellgrauer Bildhintergrund (#f2f2f2).
   Der Dateiname stammt von der ersten Fassung (26.10.2026), die alles weiss
   gemacht hat. Verworfen, weil weisse Ware auf weissem Grund verschwand.
   Houda, 26.10.2026: Kacheln sahen uneinheitlich aus (SpreadConnect-Fotos
   grau, MarketPrint weiss), und weisse Hoodies verschwanden auf weissem Grund.
   Darum steht jedes Produktbild jetzt auf #f2f2f2, gesetzt per CSS am
   Bildrahmen (.product-media, teeinblue-Galerie).
   - Transparente Bilder (die meisten MarketPrint-Bilder): Grau scheint durch,
     nichts weiter zu tun.
   - SpreadConnect-Fotos haben schon #f2f2f2: nichts zu tun.
   - Bilder mit eingebranntem weissem oder fast weissem Grund (MarketPrint-JPG,
     Tassen #fafafa, JAKO-Fotos): das Skript laedt eine 256 px Fassung, sucht
     von den Raendern aus die zusammenhaengende Hintergrundflaeche (Flutfuellung)
     und legt eine Maske ueber das Bild, die genau diese Flaeche ausblendet.
     Die Ware bleibt unveraendert, der Grund wird grau.
   Fotos mit unruhigen Ecken (Modelfotos) werden nicht angefasst.
   Houda, 28.10.2026: Tasse sah unten komisch aus. Fotos mit fast weissem,
   aber nicht reinweissem Grund (Tassen #fafafa) haben einen weichen Schatten
   im Bild. Die Maske schnitt mitten durch diesen Verlauf, der Rest stand als
   heller Fleck mit Kante da, der Kachelschatten (cv-kachelschatten.css) hat
   ihn zusaetzlich umrandet. Darum: Grund unter 253 wird nicht maskiert,
   sondern per mix-blend-mode multiply auf den grauen Grund gelegt, vorher mit
   brightness auf Weiss angehoben. Der Grund wird genau #f2f2f2, der Schatten
   im Foto bleibt natuerlich erhalten. Fuer solche Bilder ist der Kachelschatten
   aus (:has(img.cv-multi)). Reinweisse Grunde (255, MarketPrint-Mockups)
   werden weiter maskiert.
   Houda, 28.10.2026 abends: weisse Ware auf reinweissem Grund (Kinder
   Vereins-Hoodie, JAKO Kapuzenjacke Damen) sah zerrissen aus, weil die
   Flutfuellung ueber helle Kanten in die Ware hineinlief. Darum wird 3 px
   innen neben der Hintergrundflaeche gemessen. Ist dort ueberwiegend Hell,
   ist die Ware selbst weiss. Dann wird feiner gerechnet (512 px, nur 254 und
   255 gelten als Grund), damit die grauen Kantenlinien der Ware die Fuellung
   stoppen, und bis 4 px neben dem Grund wird nach Helligkeit und Abstand
   weich ueberblendet (keine weissen Treppenkanten, kein grauer Streifen). Erste Fassung liess diese Bilder weiss, das sah uneinheitlich aus
   (Houda, 28.10.2026, 22 Uhr).
   Probe: getComputedStyle(document.documentElement)
   .getPropertyValue('--cv-bild-grund') liefert "on",
   '--cv-bild-grund-v' liefert "6". */
(function () {
  if (window.cvBildGrund) return;
  window.cvBildGrund = true;
  var GRAU = 242;
  // .cvv .card img: eigene Produktkacheln auf der Seite Vereine
  var ZIEL = '.product-media img, [class*="tee-mockup"] img, [class*="tee-slide"] img, .cvv .card img';

  function stilEinbauen() {
    var s = document.createElement('style');
    s.textContent = ':root{--cv-bild-grund:on;--cv-bild-grund-v:6}' +
      '.product-media,.tee-slide,.tee-mockup-item,.tee-mockup-thumbnail,.cvv .card img{background-color:#f2f2f2!important}' +
      'img.cv-maske{-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat;-webkit-mask-position:center;mask-position:center}' +
      'img.cv-multi{mix-blend-mode:multiply}' +
      'product-card .product-media:has(img.cv-multi){background-color:#f2f2f2!important;filter:none!important}' +
      // teeinblue-Galerie: multiply braucht den Grau-Grund direkt am Elternelement
      '[class*="tee-"]:has(> img.cv-multi){background-color:#f2f2f2!important}';
    document.head.appendChild(s);
  }

  // je Datei: '' = nichts tun, sonst Masken-Adresse (data:image/png)
  // Schluessel cvGrund6: alte Masken (cvGrund2) aus der Sitzung nicht weiterverwenden
  var cache = {};
  try { cache = JSON.parse(sessionStorage.getItem('cvGrund6') || '{}'); } catch (e) {}
  function merken() { try { sessionStorage.setItem('cvGrund6', JSON.stringify(cache)); } catch (e) {} }
  var laufend = {};

  function datei(img) {
    var u = img.currentSrc || img.src || '';
    var m = u.match(/\/(?:cdn\/shop|s\/files\/[\d\/]+)\/files\/([^?#]+\.(?:webp|png|jpe?g))/i);
    if (m) return m[1];
    m = u.match(/^https:\/\/cdn\.teeinblue\.com\/[^?#]+\.(?:webp|png|jpe?g)/i);
    return m ? m[0] : null;
  }

  function maskeBauen(name) {
    if (laufend[name]) return laufend[name];
    var url = name.indexOf('https://') === 0 ? name : '/cdn/shop/files/' + name + '?width=512';
    laufend[name] = fetch(url, { mode: 'cors' })
      .then(function (r) { return r.blob(); })
      .then(function (b) { return createImageBitmap(b); })
      .then(function (bm) {
        var W = 256, H = Math.max(16, Math.round(256 * bm.height / bm.width));
        var c = document.createElement('canvas'); c.width = W; c.height = H;
        var x = c.getContext('2d'); x.drawImage(bm, 0, 0, W, H);
        var px = x.getImageData(0, 0, W, H).data;
        // Ecken pruefen: deckend, neutral, hell, untereinander gleich
        var ecken = [[1, 1], [W - 2, 1], [1, H - 2], [W - 2, H - 2]], ref = -1, ok = true;
        ecken.forEach(function (p) {
          var i = (p[1] * W + p[0]) * 4, r = px[i], g = px[i + 1], bl = px[i + 2], a = px[i + 3];
          if (a < 250 || Math.max(r, g, bl) - Math.min(r, g, bl) > 6 || r < 236) ok = false;
          if (ref < 0) ref = r; else if (Math.abs(ref - r) > 4) ok = false;
        });
        if (!ok || Math.abs(ref - GRAU) <= 3) return '';
        // fast weiss mit Fotoschatten: multiplizieren statt maskieren
        if (ref < 253) return 'M' + ref;
        // Flutfuellung von allen Randpixeln, die dem Eckwert entsprechen
        var tol = 6, bg = new Uint8Array(W * H), st = [];
        function nah(k) { var i = k * 4; return px[i + 3] > 245 && Math.abs(px[i] - ref) <= tol && Math.abs(px[i + 1] - ref) <= tol && Math.abs(px[i + 2] - ref) <= tol; }
        function rein(k) { if (!bg[k] && nah(k)) { bg[k] = 1; st.push(k); } }
        for (var xx = 0; xx < W; xx++) { rein(xx); rein((H - 1) * W + xx); }
        for (var yy = 0; yy < H; yy++) { rein(yy * W); rein(yy * W + W - 1); }
        while (st.length) {
          var k = st.pop(), kx = k % W;
          if (kx > 0) rein(k - 1);
          if (kx < W - 1) rein(k + 1);
          if (k >= W) rein(k - W);
          if (k < W * (H - 1)) rein(k + W);
        }
        // Weisse Ware erkennen: Band 3 px innen neben der Hintergrundflaeche
        var dist = new Uint8Array(W * H), fr = [];
        for (var q0 = 0; q0 < W * H; q0++) { if (bg[q0]) fr.push(q0); else dist[q0] = 9; }
        for (var stp = 1; stp <= 3; stp++) {
          var nf = [];
          for (var f0 = 0; f0 < fr.length; f0++) {
            var kk = fr[f0], kkx = kk % W, nb = [kkx > 0 ? kk - 1 : -1, kkx < W - 1 ? kk + 1 : -1, kk >= W ? kk - W : -1, kk < W * (H - 1) ? kk + W : -1];
            for (var n0 = 0; n0 < 4; n0++) { var nn = nb[n0]; if (nn >= 0 && dist[nn] === 9) { dist[nn] = stp; nf.push(nn); } }
          }
          fr = nf;
        }
        var band = 0, hell = 0;
        for (var q1 = 0; q1 < W * H; q1++) {
          if (dist[q1] !== 3) continue;
          band++;
          var i1 = q1 * 4;
          if (Math.min(px[i1], px[i1 + 1], px[i1 + 2]) >= 215) hell++;
        }
        if (band && hell / band >= 0.6) {
          // Weisse Ware: feiner rechnen, 512 px und nur Reinweiss (254, 255)
          // als Grund. So bleiben die grauen Kantenlinien der Ware stehen und
          // die Fuellung laeuft nicht hinein.
          W = 512; H = Math.max(16, Math.round(512 * bm.height / bm.width));
          c.width = W; c.height = H; x.drawImage(bm, 0, 0, W, H);
          px = x.getImageData(0, 0, W, H).data;
          tol = 1; bg = new Uint8Array(W * H); st = [];
          for (xx = 0; xx < W; xx++) { rein(xx); rein((H - 1) * W + xx); }
          for (yy = 0; yy < H; yy++) { rein(yy * W); rein(yy * W + W - 1); }
          while (st.length) {
            k = st.pop(); kx = k % W;
            if (kx > 0) rein(k - 1);
            if (kx < W - 1) rein(k + 1);
            if (k >= W) rein(k - W);
            if (k < W * (H - 1)) rein(k + W);
          }
        }
        // Maske: Hintergrund durchsichtig, Ware deckend, Kante 1 px weich
        var m = document.createElement('canvas'); m.width = W; m.height = H;
        var mx = m.getContext('2d'), md = mx.createImageData(W, H);
        for (var j = 0; j < W * H; j++) { md.data[j * 4 + 3] = bg[j] ? 0 : 255; }
        if (tol === 1) {
          // Weisse Ware: bis 4 px neben dem Grund weich ueberblenden. Direkt am
          // Grund entscheidet die Helligkeit (fast weiss = durchsichtig), mit
          // jedem Pixel Abstand wird das Bild sicherer deckend. 8 px nur nach
          // Helligkeit frass einen grauen Streifen in helle Aermel (gemessen
          // 28.10.2026 an der JAKO Damen-Jacke).
          var d8 = new Uint8Array(W * H), f8 = [];
          for (var a0 = 0; a0 < W * H; a0++) { if (bg[a0]) f8.push(a0); else d8[a0] = 99; }
          for (var s8 = 1; s8 <= 4; s8++) {
            var n8 = [];
            for (var b0 = 0; b0 < f8.length; b0++) {
              var p8 = f8[b0], x8 = p8 % W, nb8 = [x8 > 0 ? p8 - 1 : -1, x8 < W - 1 ? p8 + 1 : -1, p8 >= W ? p8 - W : -1, p8 < W * (H - 1) ? p8 + W : -1];
              for (var c0 = 0; c0 < 4; c0++) { var q8 = nb8[c0]; if (q8 >= 0 && d8[q8] === 99) { d8[q8] = s8; n8.push(q8); } }
            }
            f8 = n8;
          }
          for (var e0 = 0; e0 < W * H; e0++) {
            if (d8[e0] < 1 || d8[e0] > 4) continue;
            var lum = Math.min(px[e0 * 4], px[e0 * 4 + 1], px[e0 * 4 + 2]);
            var aL = (255 - lum) / 13, aD = (d8[e0] - 1) / 3;
            md.data[e0 * 4 + 3] = Math.max(0, Math.min(255, Math.round(Math.max(aL, aD) * 255)));
          }
          mx.putImageData(md, 0, 0);
          return m.toDataURL('image/png');
        }
        mx.putImageData(md, 0, 0);
        var w2 = document.createElement('canvas'); w2.width = W; w2.height = H;
        var wx = w2.getContext('2d'); wx.filter = 'blur(0.6px)'; wx.drawImage(m, 0, 0);
        return w2.toDataURL('image/png');
      })
      .then(function (v) { cache[name] = v; merken(); return v; })
      .catch(function () { cache[name] = ''; return ''; });
    return laufend[name];
  }

  function setzen(img, name, v) {
    if (img.dataset.cvG !== name) return;
    if (v && v.charAt(0) === 'M') {
      img.classList.remove('cv-maske');
      img.style.removeProperty('-webkit-mask-image'); img.style.removeProperty('mask-image');
      img.style.setProperty('filter', 'brightness(' + (255 / parseInt(v.slice(1), 10)).toFixed(4) + ')');
      img.classList.add('cv-multi');
      return;
    }
    img.classList.remove('cv-multi'); img.style.removeProperty('filter');
    if (!v) {
      img.classList.remove('cv-maske');
      img.style.removeProperty('-webkit-mask-image'); img.style.removeProperty('mask-image');
      return;
    }
    // Maske muss so liegen wie das Bild im Rahmen (object-fit)
    var fit = getComputedStyle(img).objectFit, gr = fit === 'cover' ? 'cover' : fit === 'contain' || fit === 'scale-down' ? 'contain' : '100% 100%';
    img.style.setProperty('-webkit-mask-image', 'url(' + v + ')'); img.style.setProperty('mask-image', 'url(' + v + ')');
    img.style.setProperty('-webkit-mask-size', gr); img.style.setProperty('mask-size', gr);
    img.classList.add('cv-maske');
  }

  function pruefen(img) {
    var name = datei(img);
    if (!name || img.dataset.cvG === name) return;
    img.dataset.cvG = name;
    if (name in cache) { setzen(img, name, cache[name]); return; }
    maskeBauen(name).then(function (v) { setzen(img, name, v); });
  }

  function alle() { document.querySelectorAll(ZIEL).forEach(pruefen); }
  var q = false;
  function spaeter() { if (q) return; q = true; requestAnimationFrame(function () { q = false; alle(); }); }

  function start() {
    stilEinbauen();
    alle();
    new MutationObserver(spaeter).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'srcset'] });
    document.addEventListener('load', function (e) { if (e.target && e.target.tagName === 'IMG' && e.target.matches(ZIEL)) pruefen(e.target); }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
